import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { Navigate } from "react-router-dom";
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import { createRef } from 'react';

export default class UserLogs extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.dt = createRef();
        this.state = {
            userLogList: [],
            route: null,
            isLoading: false,
            dateRange: null,
            totalRecords: 0,
            filterDetails: {
                start: 0,
                length: 50,
                search: '',
                userId: '',
                sortField: '',
                sortOrder: 'asc',
                startDate: '',
                endDate: ''
            },
            userList: [],
        };
        this.exportCSV = this.exportCSV.bind(this);
        this.exportPdf = this.exportPdf.bind(this);
        this.exportExcel = this.exportExcel.bind(this);
        this.saveAsExcelFile = this.saveAsExcelFile.bind(this);
    }

    componentDidMount() {
        this.userLogs();
    }

    userLogs = () => {
        let filterDetials = this.state.filterDetails;
        this.setState({ isLoading: true })
        let request = [filterDetials.start,
        filterDetials.length,
        filterDetials.userId,
        filterDetials.sortField,
        filterDetials.sortOrder,
        filterDetials.startDate && Number(moment(filterDetials.startDate).format('YYYYMMDD')),
        filterDetials.endDate && Number(moment(filterDetials.endDate).format('YYYYMMDD'))
        ];
        this.adminServices.userLogs(request).then((response) => {
            if (response && response.data && response !== null) {
                let res = response.data;
                res.map((x, index) => {
                    x.srNo = index + 1
                })
                this.setState({ userLogList: res, totalRecords: response.totalRecords });
                this.setState({ isLoading: false }, () => {
                    this.getUserList()
                })
            }
        });
    }

    getUserList = () => {
        const request = [0, -1, '', '', '', '', '', ''];
        this.adminServices.getUserList(request).then((response) => {
            if (response && response.data && response !== null) {
                let dropdownItems = response.data.map((item) => ({
                    label: item.username,
                    value: item.userid,
                }));
                this.setState({ userList: dropdownItems });
            }
        });
    }

    handleSearch = (value) => {
        let details = this.state.filterDetails
        details.search = value;
        this.setState({ filterDetails: details }, () => {
            this.userLogs();

        });
    }

    handleChangeDateRange = (value) => {
        let details = this.state.filterDetails

        if (value[0]) {
            details.startDate = value[0];
            details.startDate = details.startDate.setHours(0, 0, 0, 0);
        }

        if (value[1]) {
            details.endDate = value[1];
            details.endDate = details.endDate.setHours(23, 59, 59, 999);
        }
        this.setState({ filterDetails: details, dateRange: value }, () => {
            if (this.state.filterDetails.startDate && this.state.filterDetails.endDate) {
                this.userLogs();
            }

        });
    }

    resetFilter = () => {
        let details = this.state.filterDetails
        details.search = '';
        details.startDate = '';
        details.endDate = '';
        details.userId = ''
        this.setState({ filterDetails: details, dateRange: null }, () => {
            this.userLogs()
        });
    }

    onPageChange = (event) => {
        let details = this.state.filterDetails
        details.start = event.first;
        details.length = event.rows;
        this.setState({ filterDetails: details }, () => {
            this.userLogs();
        })
    };

    onSortChange = (event) => {
        const filterDetails = { ...this.state.filterDetails };
        filterDetails.sortField = event.sortField;
        filterDetails.sortOrder = event.sortOrder === 1 ? 'asc' : 'desc';
        this.setState({ filterDetails }, () => {
            this.userLogs();
        });
    };

    handleSelectChange = (event) => {
        let details = this.state.filterDetails;
        details.userId = event.target.value === '0' ? '' : event.target.value;
        this.setState({ filterDetails: details }, () => {
            this.userLogs()
        });
    };

    // exportCSV(selectionOnly) {
    //     if (this.dt.current) {
    //         this.dt.current.exportCSV({
    //             selectionOnly,
    //             filename: 'custom-filename'
    //         });
    //     }
    // }

    exportCSV(selectionOnly) {
        if (this.dt.current) {
            const data = selectionOnly ? this.dt.current.props.value.filter(row => this.dt.current.isSelected(row)) : this.dt.current.props.value;

            let csv = '';
            const columns = this.dt.current.props.children;

            csv += columns.map(col => col.props.header).join(',') + '\n';

            data.forEach(rowData => {
                const row = columns.map(col => {
                    const field = col.props.field;
                    return '"' + (rowData[field] !== undefined ? rowData[field] : '') + '"';
                });
                csv += row.join(',') + '\n';
            });

            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const filename = 'User Logs.csv';

            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const url = URL.createObjectURL(blob);
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    getExportColumns() {
        return this.state.userLogList.map((col) => ({ title: 'ABC', dataKey: 'XYZ' }));
    }

    exportPdf() {
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                const exportColumns = this.getExportColumns();
                doc.autoTable(exportColumns, this.state.userLogList);
                doc.save('User Logs.pdf');
            });
        });
    }

    saveAsExcelFile(buffer, fileName) {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], { type: EXCEL_TYPE });

                module.default.saveAs(data, "User Logs" + EXCEL_EXTENSION);
            }
        });
    }

    exportExcel() {
        import('xlsx').then((xlsx) => {
            const modifiedData = this.state.userLogList.map(({ logid, ...rest }) => {
                const { srNo, ...others } = rest;
                return { srNo, ...others };
            });

            const worksheet = xlsx.utils.json_to_sheet(modifiedData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });

            this.saveAsExcelFile(excelBuffer, 'userLogList');
        });
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }

        const pageSizes = [5, 10, 20, 50, 100];
        let rowsPerPageOptions = pageSizes.filter(size => size < this.state.totalRecords);

        if (!rowsPerPageOptions.includes(this.state.totalRecords)) {
            rowsPerPageOptions.push(this.state.totalRecords);
        }

        const paginatorRight = (
            <div className="flex gap-2">
                <Button label="Export CSV" icon="pi pi-file" className="export-btn" onClick={() => this.exportCSV(false)} />
                {/* <Button label="Export PDF" icon="pi pi-file-pdf" className="export-btn" onClick={this.exportPdf} /> */}
                <Button label="Export Excel" icon="pi pi-file-excel" className="export-btn" onClick={this.exportExcel} />
            </div>
        );

        return (
            <div className='user-lists'
                style={{ height: "calc((100dvh / 0.85) - 60.8px)" }}
            >
                <div className='user-lists-inner p-[30px]'>
                    <div className='title flex items-center justify-between mb-[10px]'>
                        <h1 className='text-[22px] m-0 font-semibold text-[#004AAD]' style={{ lineHeight: "30px" }}>User logs</h1>
                    </div>
                    <div className='user-table p-5 bg-white rounded-[16px]' style={{ border: "1px solid #DFDFDF" }}>
                        <div className='table-inner grid grid-cols-3 gap-5 items-end'>
                            <div className='input-grp !mb-0'>
                                <label>User role:</label>
                                <select value={this.state.filterDetails.userId} onChange={this.handleSelectChange}>
                                    <option value={0}>Select</option>
                                    {this.state.userList.map((role, index) => (
                                        <option key={index} value={role.value}>
                                            {role.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="input-grp !mb-0">
                                <label>
                                    Filter by Date Range
                                </label>
                                <Calendar
                                    value={this.state.dateRange}
                                    onChange={(e) => this.handleChangeDateRange(e.value)}
                                    selectionMode="range"
                                    placeholder="Select date range"
                                    dateFormat="yy-mm-dd"
                                    readOnlyInput
                                    numberOfMonths={2}
                                    maxDate={new Date()}
                                    style={{ height: "42px" }}
                                />
                            </div>
                            <Button
                                label="Reset filters"
                                className='w-fit h-fit'
                                onClick={() => this.resetFilter()}
                                style={{ fontWeight: "400", lineHeight: "1" }}
                            />
                        </div>
                        <div className='sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white mt-[30px]'>
                            <DataTable
                                value={this.state.userLogList}
                                paginator
                                lazy
                                first={this.state.filterDetails.start}
                                rows={(this.state.totalRecords > this.state.filterDetails.length) ? this.state.filterDetails.length : this.state.totalRecords}
                                totalRecords={this.state.totalRecords}
                                onPage={(e) => this.onPageChange(e)}
                                rowsPerPageOptions={rowsPerPageOptions}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 360px)"
                                className="min-w-full"
                                emptyMessage="No data found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                                onSort={(e) => this.onSortChange(e)}
                                sortField={this.state.filterDetails.sortField}
                                sortOrder={this.state.filterDetails.sortOrder === 'asc' ? 1 : -1}
                                paginatorRight={paginatorRight}
                                ref={this.dt}
                            >
                                <Column
                                    field="srNo"
                                    header="Sr No"
                                    body={(rowData, options) => options.rowIndex + 1}
                                    filterPlaceholder="Search by ID"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="username"
                                    header="Username"
                                    sortable
                                    filterPlaceholder="Search by username"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="login"
                                    header="Login date"
                                    sortable
                                    filterPlaceholder="Search by login date"
                                    // filterFunction={this.filterByDateRange}
                                    // filterElement={this.dateRangeFilterTemplate}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="logout"
                                    header="Logout date"
                                    sortable
                                    filterPlaceholder="Search by logout date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="logintype"
                                    header="Login type"
                                    sortable
                                    filterPlaceholder="Search by logout date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                                <Column
                                    field="ip"
                                    header="IP"
                                    sortable
                                    filterPlaceholder="Search by login date"
                                    headerClassName="bg-blue-50 text-blue-800 font-medium">
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}